import "core-js/modules/es.array.reverse.js";
const _excluded = ["planes"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import i18next from "i18next";
import { action, computed, makeObservable, observable, toJS, untracked } from "mobx";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import clone from "terriajs-cesium/Source/Core/clone";
import Color from "terriajs-cesium/Source/Core/Color";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import HeadingPitchRoll from "terriajs-cesium/Source/Core/HeadingPitchRoll";
import Matrix3 from "terriajs-cesium/Source/Core/Matrix3";
import Matrix4 from "terriajs-cesium/Source/Core/Matrix4";
import Transforms from "terriajs-cesium/Source/Core/Transforms";
import ClippingPlane from "terriajs-cesium/Source/Scene/ClippingPlane";
import ClippingPlaneCollection from "terriajs-cesium/Source/Scene/ClippingPlaneCollection";
import filterOutUndefined from "../Core/filterOutUndefined";
import runLater from "../Core/runLater";
import BoxDrawing from "../Models/BoxDrawing";
import CommonStrata from "../Models/Definition/CommonStrata";
import updateModelFromJson from "../Models/Definition/updateModelFromJson";
import Icon from "../Styled/Icon";
import HeadingPitchRollTraits from "../Traits/TraitsClasses/HeadingPitchRollTraits";
import LatLonHeightTraits from "../Traits/TraitsClasses/LatLonHeightTraits";
function ClippingMixin(Base) {
  var _class, _descriptor, _descriptor2, _descriptor3;
  let ClippingMixinBase = (_class = class ClippingMixinBase extends Base {
    constructor() {
      super(...arguments);
      _defineProperty(this, "_clippingBoxDrawing", void 0);
      /**
       * Indicates whether we are currently zooming to the clipping box
       */
      _initializerDefineProperty(this, "_isZoomingToClippingBox", _descriptor, this);
      /**
       * A trigger for activating the clipping box repositioning UI for this item.
       */
      _initializerDefineProperty(this, "repositionClippingBoxTrigger", _descriptor2, this);
      _defineProperty(this, "clippingPlaneModelMatrix", Matrix4.IDENTITY.clone());
      // Use a stable clipping plane collection. Replacing the collection on
      // change seems to crash Cesium, which could be related to:
      // https://github.com/CesiumGS/cesium/issues/6599 .
      _initializerDefineProperty(this, "_clippingPlaneCollection", _descriptor3, this);
      makeObservable(this);
    }
    get hasClippingMixin() {
      return true;
    }
    get inverseClippingPlanesOriginMatrix() {
      return Matrix4.inverse(this.clippingPlanesOriginMatrix(), new Matrix4());
    }
    get simpleClippingPlaneCollection() {
      if (!this.clippingPlanes) {
        return;
      }
      if (this.clippingPlanes.planes.length === 0) {
        return;
      }
      const {
        planes,
        enabled = true,
        unionClippingRegions = false,
        edgeColor,
        edgeWidth,
        modelMatrix
      } = this.clippingPlanes;
      const planesMapped = planes.map(plane => {
        return new ClippingPlane(Cartesian3.fromArray(plane.normal || []), plane.distance);
      });
      let options = {
        planes: planesMapped,
        enabled,
        unionClippingRegions
      };
      if (edgeColor && edgeColor.length > 0) {
        options = Object.assign(options, {
          edgeColor: Color.fromCssColorString(edgeColor) || Color.WHITE
        });
      }
      if (edgeWidth && edgeWidth > 0) {
        options = Object.assign(options, {
          edgeWidth: edgeWidth
        });
      }
      if (modelMatrix && modelMatrix.length > 0) {
        const array = clone(toJS(modelMatrix));
        options = Object.assign(options, {
          modelMatrix: Matrix4.fromArray(array) || Matrix4.IDENTITY
        });
      }
      const clippingPlaneCollection = this.getOrCreateClippingPlanesCollection();
      return updateClippingPlanesCollection(clippingPlaneCollection, options);
    }
    get clippingBoxPlaneCollection() {
      if (!this.clippingBox.enableFeature) {
        return;
      }
      const clippingPlaneCollection = this.getOrCreateClippingPlanesCollection();
      if (!this.clippingBox.clipModel) {
        clippingPlaneCollection.enabled = false;
        return clippingPlaneCollection;
      }
      const clipDirection = this.clippingBox.clipDirection === "inside" ? -1 : 1;
      const planes = BoxDrawing.localSidePlanes.map(plane => {
        return new ClippingPlane(plane.normal, plane.distance * clipDirection);
      });
      untracked(() => {
        Matrix4.multiply(this.inverseClippingPlanesOriginMatrix, this.clippingBoxTransform, this.clippingPlaneModelMatrix);
      });
      updateClippingPlanesCollection(clippingPlaneCollection, {
        modelMatrix: this.clippingPlaneModelMatrix,
        planes,
        unionClippingRegions: this.clippingBox.clipDirection === "outside",
        enabled: this.clippingBox.clipModel
      });
      return clippingPlaneCollection;
    }
    getOrCreateClippingPlanesCollection() {
      if (this._clippingPlaneCollection) {
        return this._clippingPlaneCollection;
      }
      this._clippingPlaneCollection = new ClippingPlaneCollection();

      // Unset our reference if the collection gets destroyed.
      // This could happen for example when switching to 2D mode and back to 3D.
      const originalDestroy = this._clippingPlaneCollection.destroy;
      this._clippingPlaneCollection.destroy = action(() => {
        originalDestroy.apply(this._clippingPlaneCollection);
        this._clippingPlaneCollection = undefined;
      });
      return this._clippingPlaneCollection;
    }
    get clippingPlaneCollection() {
      var _this$simpleClippingP;
      return (_this$simpleClippingP = this.simpleClippingPlaneCollection) !== null && _this$simpleClippingP !== void 0 ? _this$simpleClippingP : this.clippingBoxPlaneCollection;
    }
    get clippingMapItems() {
      var _this$clippingBoxDraw;
      return filterOutUndefined([(_this$clippingBoxDraw = this.clippingBoxDrawing) === null || _this$clippingBoxDraw === void 0 ? void 0 : _this$clippingBoxDraw.dataSource]);
    }
    get clippingBoxDimensions() {
      var _this$clippingBox$dim, _this$clippingBox$dim2, _this$clippingBox$dim3;
      const dimensions = new Cartesian3((_this$clippingBox$dim = this.clippingBox.dimensions.length) !== null && _this$clippingBox$dim !== void 0 ? _this$clippingBox$dim : 100, (_this$clippingBox$dim2 = this.clippingBox.dimensions.width) !== null && _this$clippingBox$dim2 !== void 0 ? _this$clippingBox$dim2 : 100, (_this$clippingBox$dim3 = this.clippingBox.dimensions.height) !== null && _this$clippingBox$dim3 !== void 0 ? _this$clippingBox$dim3 : 100);
      return dimensions;
    }
    get clippingBoxHpr() {
      const {
        heading,
        pitch,
        roll
      } = this.clippingBox.rotation;
      return heading !== undefined && pitch !== undefined && roll !== undefined ? HeadingPitchRoll.fromDegrees(heading, pitch, roll) : undefined;
    }
    get clippingBoxPosition() {
      const dimensions = this.clippingBoxDimensions;
      const clippingPlanesOriginMatrix = this.clippingPlanesOriginMatrix();
      let position = LatLonHeightTraits.toCartesian(this.clippingBox.position);
      if (!position) {
        // Use clipping plane origin as position but height set to 0 so that the box is grounded.
        const cartographic = Cartographic.fromCartesian(Matrix4.getTranslation(clippingPlanesOriginMatrix, new Cartesian3()));
        // If the translation is at the center of the ellipsoid then this cartographic could be undefined.
        // Although it is not reflected in the typescript type.
        if (cartographic) {
          cartographic.height = dimensions.z / 2;
          position = Ellipsoid.WGS84.cartographicToCartesian(cartographic, new Cartesian3());
        }
      }

      // Nothing we can do - assign to zero
      position !== null && position !== void 0 ? position : position = Cartesian3.ZERO.clone();
      return position;
    }
    get clippingBoxTransform() {
      const hpr = this.clippingBoxHpr;
      const position = this.clippingBoxPosition;
      const dimensions = this.clippingBoxDimensions;
      const boxTransform = Matrix4.multiply(hpr ? Matrix4.fromRotationTranslation(Matrix3.fromHeadingPitchRoll(hpr), position) : Transforms.eastNorthUpToFixedFrame(position), Matrix4.fromScale(dimensions, new Matrix4()), new Matrix4());
      return boxTransform;
    }
    get clippingBoxDrawing() {
      const options = this.clippingBox;
      const cesium = this.terria.cesium;
      if (!cesium || !options.enableFeature || !options.clipModel || !options.showClippingBox) {
        if (this._clippingBoxDrawing) {
          this._clippingBoxDrawing = undefined;
        }
        return;
      }
      const boxTransform = this.clippingBoxTransform;
      Matrix4.multiply(this.inverseClippingPlanesOriginMatrix, boxTransform, this.clippingPlaneModelMatrix);
      if (this._clippingBoxDrawing) {
        this._clippingBoxDrawing.setTransform(boxTransform);
        this._clippingBoxDrawing.keepBoxAboveGround = this.clippingBox.keepBoxAboveGround;
      } else {
        this._clippingBoxDrawing = BoxDrawing.fromTransform(cesium, boxTransform, {
          keepBoxAboveGround: this.clippingBox.keepBoxAboveGround,
          onChange: action(_ref => {
            let {
              modelMatrix,
              isFinished
            } = _ref;
            Matrix4.multiply(this.inverseClippingPlanesOriginMatrix, modelMatrix, this.clippingPlaneModelMatrix);
            if (isFinished) {
              const position = Matrix4.getTranslation(modelMatrix, new Cartesian3());
              LatLonHeightTraits.setFromCartesian(this.clippingBox.position, CommonStrata.user, position);
              const dimensions = Matrix4.getScale(modelMatrix, new Cartesian3());
              updateModelFromJson(this.clippingBox.dimensions, CommonStrata.user, {
                length: dimensions.x,
                width: dimensions.y,
                height: dimensions.z
              }).logError("Failed to update clipping box dimensions");
              const rotationMatrix = Matrix3.getRotation(Matrix4.getMatrix3(modelMatrix, new Matrix3()), new Matrix3());
              HeadingPitchRollTraits.setFromRotationMatrix(this.clippingBox.rotation, CommonStrata.user, rotationMatrix);
            }
          })
        });
      }
      return this._clippingBoxDrawing;
    }
    get isClippingBoxPlaced() {
      const {
        longitude,
        latitude,
        height
      } = this.clippingBox.position;
      return longitude !== undefined && latitude !== undefined && height !== undefined;
    }
    get clippingDimensions() {
      if (!this.clippingBox.enableFeature) {
        return [];
      }
      const checkboxGroupInputs = this.repositionClippingBoxTrigger ? [
        /* don't show options when repositioning clipping box */
      ] : [{
        // Checkbox to show/hide clipping box
        id: "show-clip-editor-ui",
        type: "checkbox",
        selectedId: this.clippingBox.showClippingBox ? "true" : "false",
        disable: this.clippingBox.clipModel === false,
        options: [{
          id: "true",
          name: i18next.t("models.clippingBox.showClippingBox")
        }, {
          id: "false",
          name: i18next.t("models.clippingBox.showClippingBox")
        }],
        setDimensionValue: (stratumId, value) => {
          this.clippingBox.setTrait(stratumId, "showClippingBox", value === "true");
        }
      }, {
        // Checkbox to clamp/unclamp box to ground
        id: "clamp-box-to-ground",
        type: "checkbox",
        selectedId: this.clippingBox.keepBoxAboveGround ? "true" : "false",
        disable: this.clippingBox.clipModel === false || this.clippingBox.showClippingBox === false,
        options: [{
          id: "true",
          name: i18next.t("models.clippingBox.keepBoxAboveGround")
        }, {
          id: "false",
          name: i18next.t("models.clippingBox.keepBoxAboveGround")
        }],
        setDimensionValue: (stratumId, value) => {
          this.clippingBox.setTrait(stratumId, "keepBoxAboveGround", value === "true");
        }
      }, {
        // Dropdown to change the clipping direction
        id: "clip-direction",
        name: i18next.t("models.clippingBox.clipDirection.name"),
        type: "select",
        selectedId: this.clippingBox.clipDirection,
        disable: this.clippingBox.clipModel === false || this.clippingBox.showClippingBox === false,
        options: [{
          id: "inside",
          name: i18next.t("models.clippingBox.clipDirection.options.inside")
        }, {
          id: "outside",
          name: i18next.t("models.clippingBox.clipDirection.options.outside")
        }],
        setDimensionValue: (stratumId, value) => {
          this.clippingBox.setTrait(stratumId, "clipDirection", value);
        }
      }, ...this.repositioningAndZoomingDimensions];
      return [{
        // Checkbox group that also enables/disables the clipping behaviour altogether
        type: "checkbox-group",
        id: "clipping-box",
        selectedId: this.clippingBox.clipModel ? "true" : "false",
        options: [{
          id: "true",
          name: "".concat(i18next.t("models.clippingBox.clipModel"))
        }, {
          id: "false",
          name: i18next.t("models.clippingBox.clipModel")
        }],
        emptyText: "Click on map to position clipping box",
        setDimensionValue: action((stratumId, value) => {
          const clipModel = value === "true";
          this.clippingBox.setTrait(stratumId, "clipModel", clipModel);

          // Trigger clipping box repositioning UI if the feature is enabled
          // and a box position is not already set.
          const triggerClippingBoxRepositioning = !this.isClippingBoxPlaced;
          if (triggerClippingBoxRepositioning) {
            this.repositionClippingBoxTrigger = true;
          }
        }),
        selectableDimensions: checkboxGroupInputs
      }];
    }

    /**
     * Returns controls for repositioning and zooming to clipping box. Note
     * that these are temporary features that are enabled through a feature
     * flag. It will get removed once we switch to a new design for a global
     * clipping box.
     */
    get repositioningAndZoomingDimensions() {
      const repositioningAndZoomingInputs = [{
        // Button to zoom to clipping box
        id: "zoom-to-clipping-box-button",
        type: "button",
        value: "Zoom to&nbsp;&nbsp;&nbsp;",
        icon: this._isZoomingToClippingBox ? "spinner" : Icon.GLYPHS.search,
        disable: this.clippingBox.clipModel === false || this.clippingBoxDrawing === undefined,
        setDimensionValue: () => {
          if (!this._isZoomingToClippingBox) {
            this._zoomToClippingBox();
          }
        }
      }, {
        id: "reposition-clipping-box",
        type: "button",
        value: "Reposition",
        icon: Icon.GLYPHS.geolocation,
        disable: this.clippingBox.clipModel === false || this.clippingBoxDrawing === undefined,
        setDimensionValue: action(() => {
          // Disable repositioning tool if already active
          if (this.repositionClippingBoxTrigger) {
            this.repositionClippingBoxTrigger = false;
            return;
          }

          // Enable repositioning tool, but first disable it for other workbench items
          this.terria.workbench.items.forEach(it => {
            if (ClippingMixin.isMixedInto(it)) {
              it.repositionClippingBoxTrigger = false;
            }
          });
          this.repositionClippingBoxTrigger = true;
        })
      }];
      return repositioningAndZoomingInputs;
    }

    /**
     * Initiates zooming to the clipping box if it is rendered on the map.
     * Times out in 3 seconds if zooming is not possible.
     *
     * Also sets the observable variable `_isZoomingToClippingBox` to indicate the
     * zooming status.
     */
    _zoomToClippingBox() {
      var _this$clippingBoxDraw2;
      const dataSource = (_this$clippingBoxDraw2 = this.clippingBoxDrawing) === null || _this$clippingBoxDraw2 === void 0 ? void 0 : _this$clippingBoxDraw2.dataSource;
      const cesium = this.terria.cesium;
      if (!dataSource || !cesium) {
        return;
      }
      this._isZoomingToClippingBox = true;
      zoomToDataSourceWithTimeout(dataSource, 3000,
      // timeout after 3 seconds if we cannot zoom for some reason
      cesium).catch(() => {
        /* ignore errors */
      }).finally(action(() => {
        this._isZoomingToClippingBox = false;
      }));
    }
  }, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_isZoomingToClippingBox", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "repositionClippingBoxTrigger", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_clippingPlaneCollection", [observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "inverseClippingPlanesOriginMatrix", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inverseClippingPlanesOriginMatrix"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxPlaneCollection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxPlaneCollection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingPlaneCollection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingPlaneCollection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingMapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingMapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxHpr", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxHpr"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxTransform", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxTransform"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingBoxDrawing", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingBoxDrawing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isClippingBoxPlaced", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isClippingBoxPlaced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clippingDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clippingDimensions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "repositioningAndZoomingDimensions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "repositioningAndZoomingDimensions"), _class.prototype), _class);
  return ClippingMixinBase;
}
/**
 * Update a clipping plane collection instance with the given options
 */
function updateClippingPlanesCollection(clippingPlaneCollection, options) {
  const {
      planes
    } = options,
    otherOptions = _objectWithoutProperties(options, _excluded);
  Object.assign(clippingPlaneCollection, otherOptions);
  if (planes) {
    clippingPlaneCollection.removeAll();
    planes.forEach(plane => clippingPlaneCollection.add(plane));
  }
  return clippingPlaneCollection;
}

/**
 * Zooms to the given dataSource and returns a promise that fullfills when the
 * zoom action is complete. If the dataSource has not been rendered on the map,
 * we wait for `timeoutMilliseconds` before rejecting the promise.
 */
function zoomToDataSourceWithTimeout(dataSource, timeoutMilliseconds, cesium) {
  // DataSources rendered on the map
  const renderedDataSources = cesium.dataSources;
  if (renderedDataSources.contains(dataSource)) {
    return cesium.doZoomTo(dataSource);
  } else {
    // Create a promise that waits for the dataSource to be added to map or
    // timeout to complete whichever happens first
    return new Promise((resolve, reject) => {
      const removeListener = renderedDataSources.dataSourceAdded.addEventListener((_, added) => {
        if (added === dataSource) {
          removeListener();
          resolve(cesium.doZoomTo(dataSource));
        }
      });
      runLater(removeListener, timeoutMilliseconds).then(reject);
    });
  }
}
(function (_ClippingMixin) {
  function isMixedInto(model) {
    return (model === null || model === void 0 ? void 0 : model.hasClippingMixin) === true;
  }
  _ClippingMixin.isMixedInto = isMixedInto;
})(ClippingMixin || (ClippingMixin = {}));
export default ClippingMixin;